import axiosClient from './axiosClient';
import type { UserRole } from '@/types/common';

export type RoleRequestStatus = 'PENDING' | 'APPROVED' | 'REJECTED';

export interface RoleRequestDto {
  id?: string;
  userId?: string;
  userFullName?: string;
  userEmail?: string;
  currentRole?: UserRole;
  requestedRole?: UserRole;
  reason?: string;
  status?: RoleRequestStatus;
  reviewedByName?: string;
  reviewedAt?: string;
  rejectionReason?: string;
  createdAt?: string;
}

export const roleRequestApi = {
  /** Submit a secondary role request (authenticated user). */
  submit: (data: { requestedRole: UserRole; reason?: string }) =>
    axiosClient.post<{ success: boolean; message: string; data: RoleRequestDto }>(
      '/role-requests',
      data,
    ),

  /** Admin/CEO: list all role requests with optional status filter. */
  list: (params?: { status?: RoleRequestStatus; page?: number; size?: number }) =>
    axiosClient.get<{
      success: boolean;
      data: { content: RoleRequestDto[]; totalElements: number };
    }>('/admin/role-requests', { params }),

  /** Admin/CEO: pending count for badge. */
  getPendingCount: () =>
    axiosClient.get<{ success: boolean; data: { count: number } }>(
      '/admin/role-requests/pending-count',
    ),

  /** Admin/CEO: approve a role request. */
  approve: (id: string) =>
    axiosClient.put<{ success: boolean; message: string; data: RoleRequestDto }>(
      `/admin/role-requests/${id}/approve`,
    ),

  /** Admin/CEO: reject a role request with a reason. */
  reject: (id: string, rejectionReason: string) =>
    axiosClient.put<{ success: boolean; message: string; data: RoleRequestDto }>(
      `/admin/role-requests/${id}/reject`,
      { rejectionReason },
    ),

  /** Admin/CEO: remove a user's secondary role. */
  removeSecondaryRole: (userId: string) =>
    axiosClient.delete(`/admin/users/${userId}/secondary-role`),
};
